import { z } from 'zod';

export const approximateCosts$ = z.object({
  currency: z.string(),
  amount: z.number()
});

export const statisticsData$ = z.object({
  totalHours: z.number(),
  totalCosts: approximateCosts$
});

export const bookingStatisticsResponse$ = z.object({
  data: statisticsData$
});
